export default "__VITE_ASSET__DRVHQYAJ__"